export const ADMIN_FORBIDDEN_MESSAGE = 'You are not authorized to view this dashboard.';

export function adminDashboardErrorMessage(err, fallback = 'Could not load dashboard') {
  if (err?.status === 403) return ADMIN_FORBIDDEN_MESSAGE;
  if (err?.status === 408) return err.message || 'Request timed out. Try Refresh.';
  return err?.message || fallback;
}
